import { useState, useEffect, useRef } from "react";
import styles from "./style.module.scss";
import AddNewAdditionalInfo from "../addNewAdditionalInfo";
import youtubeVevo from "../../../../assets/images/creditz/vevo-youtube.png";
import spotifyZik from "../../../../assets/images/creditz/spotify-zik.png";
import PropTypes from "prop-types";

const EditNewCreditzForm = ({ values, additionalRoles }) => {
  const { selectedType = "Video" } = values;
  const optionsRef = useRef(null);
  const openIn = (url) => {
    window.open(url, "_blank");
  };
  return (
    <div className={styles.CreateNewCreditzContainer}>
      <div className={styles.selectTypeContainer} ref={optionsRef}>
        <div className={styles.selectedType}>
          <div className={styles.select}>{selectedType}</div>
        </div>
      </div>

      <div className={styles.titleContainer}>
        <p className={styles.musicTitle}>
          {values.trackName ? values.trackName : values.videoTrackName}
        </p>
        <p className={styles.musicLink} onClick={() => openIn(values.trackUrl)}>
          {selectedType === "Video" ? "Watch on YouTube" : "potify"}
        </p>
      </div>
      <div className={styles.MusicBigContainer}>
        <div>
          {selectedType === "Video" ? (
            <img
              src={values.videoImage}
              alt="youtubeVevo"
              style={{ width: 600 }}
            />
          ) : (
            <img src={spotifyZik} alt="spotifyZik" style={{ width: 345 }} />
          )}
        </div>
      </div>

      <div className={styles.additionalInfos}>
        <div className={styles.title}>Creditz</div>
        {additionalRoles.map((role, index) => (
          <AddNewAdditionalInfo
            key={index}
            username={role.username}
            selectedRole={role.role}
          />
        ))}
      </div>
    </div>
  );
};

EditNewCreditzForm.propTypes = {
  setPublishActive: PropTypes.func,
  additionalRoles: PropTypes.array
};

EditNewCreditzForm.defaultProps = {
  values: {},
  setPublishActive: () => {
  },
  additionalRoles: []
};

export default EditNewCreditzForm;
